import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Table,
} from 'react-bootstrap';
import Api from '../../../../services/Api';
import { updateSelectedUserAction, fetchUsersInitAction } from '../../../../actions/usersActions';
import Icon from '../../../atoms/Icon/Icon';
import Sidebar from '../../../molecules/Sidebar/Sidebar';
import RolesSelector from '../../../atoms/RolesSelector/RolesSelector';
import './ListUsers.scss';
import DeleteModal from '../../../molecules/DeleteModal/DeleteModal';

const ListUsers = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { usersList } = useSelector(state => state.users);
  const { user } = useSelector(state => state.auth);
  const [filtered, setFiltered] = useState(usersList);
  const [filters, setFilters] = useState([]);
  const [isDeleteModalShown, setIsDeleteModalShown] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedUser, setSelectedUser] = useState(undefined);
  useEffect(() => {
    if (user && user.role.id !== 1) {
      history.goBack();
    }
  }, [user]);
  useEffect(() => {
    const rolesIds = filters.map(f => f.value);
    if (rolesIds.length === 0) {
      setFiltered(usersList);
      return;
    }
    const users = usersList.filter(u => rolesIds.includes(parseInt(u.role.id, 10)));
    setFiltered(users);
  }, [filters, usersList, filtered]);
  const deleteUser = async () => {
    if (Number.parseInt(user.id, 10) === Number.parseInt(selectedUser.id, 10)) {
      alert('You can\'t delete yourself.');
      return;
    }
    setIsDeleting(true);
    const response = await Api.delete(`users/${selectedUser.id}`);
    if (response.status === 200 || response.status === 204) {
      setSelectedUser(undefined);
      setIsDeleteModalShown(false);
      dispatch(fetchUsersInitAction());
    }
    setIsDeleting(false);
  };
  return (
    <div className="components-page-content">
      <DeleteModal
        onDelete={deleteUser}
        isShown={isDeleteModalShown}
        isLoading={isDeleting}
        onClose={() => setIsDeleteModalShown(false)}
        isAllowed
      >
        Are you sure you want to delete
        {' '}
        <strong>{selectedUser ? selectedUser.name : ''}</strong>
        {'? '}
        <br />
        This action cannot be undone.
      </DeleteModal>
      <div className="actions-container">
        <h4 className="mb-4">Users Filters</h4>
        <div className="filters">
          <div className="actions">
            <div className="filter-item">
              <RolesSelector
                onChanged={values => setFilters(values)}
                isMulti
              />
            </div>
          </div>
          <Button
            variant="default"
            onClick={() => {
              dispatch(updateSelectedUserAction(undefined));
              history.push('/users/create');
            }}
          >
            <Icon icon="plus" color="#000" />
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8">
          <Table striped hover responsive bordered>
            <colgroup>
              <col width="10%" />
              <col width="30%" />
              <col width="30%" />
              <col width="20%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th />
                <th className="text-left">Name</th>
                <th className="text-left">Email</th>
                <th className="text-left">Role</th>
                <th className="text-center">
                  <Icon icon="cogs" color="#000" />
                </th>
              </tr>
            </thead>
            <tbody>
              {filtered && filtered.length > 0 ? filtered.map(u => (
                <tr>
                  <td />
                  <td className="text-left">{u.name}</td>
                  <td className="text-left">{u.email}</td>
                  <td className="text-left">{u.role.name}</td>
                  <td className="d-flex">
                    <Button
                      type="button"
                      variant="light"
                      onClick={() => {
                        dispatch(updateSelectedUserAction(u));
                        history.push('/users/edit');
                      }}
                    >
                      <Icon icon="eye" color="#000" />
                    </Button>
                    <Button
                      type="button"
                      variant="light"
                      className="ms-2"
                      onClick={() => {
                        setSelectedUser(u);
                        setIsDeleteModalShown(true);
                      }}
                    >
                      <Icon icon="trash" color="#000" />
                    </Button>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td className="text-center" colSpan={4}>No users found matching this filter</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="col-md-4">
          <Sidebar />
        </div>
      </div>
    </div>
  );
};

ListUsers.propTypes = {

};

ListUsers.defaultProps = {

};

export default ListUsers;
